import type { ComponentProps } from "react";
import { isMarkdownCodeBlock } from "@/lib/markdown-code-block";

export function MarkdownCode(props: ComponentProps<"code">) {
	if (isMarkdownCodeBlock(props)) {
		return <code className="font-mono">{props.children}</code>;
	}
	// リンクの中のコードは、地を付けずリンクの文字として見せる。
	return (
		<code className="in-[a]:font-sans not-in-[a]:rounded-2 not-in-[a]:bg-line-1 not-in-[a]:px-1 not-in-[a]:py-0.5 not-in-[a]:text-caption">
			{props.children}
		</code>
	);
}
